import { compose, lifecycle, withHandlers, withProps, withState } from "recompose";
import { connect } from "react-redux";
import { decodeParam } from "react-router-utils";
import { getCart } from "app/redux/selectors";
import { getCartArticles, getCartSale } from "app/redux/selectors";
import { getCartSaleId } from "app/redux/modules/cart";
import { withRouter } from "react-router-dom";
import { withTranslator } from "app/decorators";
import CheckoutCart from "./CheckoutCart";
import _clearArticleCart from "app/redux/actions/clearArticleCart";
import _fetchCart from "app/redux/actions/fetchCart";
import _removeArticleToCart from "app/redux/actions/removeArticleToCart";

const mapStateToProps = state => ({
  sale: getCartSale(state),
  saleId: getCartSaleId(getCart(state)),
  articles: getCartArticles(state)
});

function componentWillMount() {
  const { fetchCart, setIsLoading, saleId } = this.props;
  setIsLoading(true);
  if (saleId) {
    fetchCart(saleId).then(
      response => {
        setIsLoading(false);
      },
      () => {
        setIsLoading(false);
      }
    );
  } else {
    setIsLoading(false);
  }
}

const onCheckoutClear = ({ clearArticleCart }) => () => {
  clearArticleCart();
};

const onDeleteArticle = ({ removeArticleToCart }) => articleId => {
  removeArticleToCart(articleId);
};

export default compose(
  withProps(({ match }) => ({
    clubId: decodeParam(match.params.clubId)
  })),
  connect(null, {
    removeArticleToCart: _removeArticleToCart,
    fetchCart: _fetchCart,
    clearArticleCart: _clearArticleCart
  }),
  connect(mapStateToProps),
  withState("isLoading", "setIsLoading", true),
  withHandlers({ onCheckoutClear, onDeleteArticle }),
  lifecycle({ componentWillMount }),
  withRouter,
  withTranslator
)(CheckoutCart);



// WEBPACK FOOTER //
// ./src/app/components/CheckoutCart/CheckoutCartContainer.js